/** Where an AI-made value comes from: the AI marker with the file and the quote, in words (not colour). */

import type { ProposalFile, ProposalSource } from '@/api/types/extractions';
import { AiMarker } from '@/ui/AiMarker';

import './files.css';

export type FileNames = Record<string, string>;

export function fileNames(files: Pick<ProposalFile, 'id' | 'filename'>[]): FileNames {
  return Object.fromEntries(files.map((f) => [f.id, f.filename]));
}

/** `verb` says what the AI did with the value ("extracted", "proposed"). */
export function SourceNote({ source, names, what, verb = 'extracted' }: { source: ProposalSource; names: FileNames; what: string; verb?: string }) {
  const file = names[source.file_id] ?? 'a file';
  return (
    <span className="extraction-source">
      <AiMarker label={`${what} ${verb} by AI from ${file}`} rationale={source.quote} />
      <span className="hint">
        From {file}: <q>{source.quote}</q>
      </span>
    </span>
  );
}

/** A value the AI wrote from the person's own instruction, not from a file. */
export function InstructionNote({ what }: { what: string }) {
  return (
    <span className="extraction-source">
      <AiMarker label={`${what} proposed by AI from your instruction`} />
      <span className="hint">From your instruction</span>
    </span>
  );
}
